<template>
  <div class="page-content">
    <div class="box-profil-title">
      <h2>Profils voyageurs</h2>
      <div class="container-select-profil">
        <h3>Sélectionner le profil</h3>
        <b-form-select
          id="custom-profil-select"
          v-model="clientSelect"
          :options="clientOption"
        >
        </b-form-select>
      </div>
    </div>
    <div class="container-tabs-menu">
      <a
        :class="classSelect.renseignement"
        @click="changeMode('renseignement')"
      >
        <img src="../assets/renseignement.svg" />
        Renseignements personnels
      </a>
      <a :class="classSelect.passeport" @click="changeMode('passeport')">
        <img src="../assets/passeport.svg" />
        Passeport
      </a>
      <a :class="classSelect.assurance" @click="changeMode('assurance')">
        <img src="../assets/assurance.svg" />
        Assurance
      </a>
      <a :class="classSelect.paiement" @click="changeMode('paiement')">
        <img src="../assets/paiement.svg" />
        Paiement
      </a>
    </div>
    <b-row>
      <b-col>
        <b-form
          id="renseignement"
          class="contents-profils-form"
          @submit="onSubmit"
          v-show="mode === 'renseignement'"
        >
          <div class="title-sections-form">
            <p>Général</p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3">
              <b-form-group>
                <label>{{ $t("Salutation") }}</label>
                <b-form-select
                  class="input-select-form"
                  v-model="form.Salutation"
                  :options="param.Values_Salutations"
                >
                  <template #first>
                    <!-- This is required to prevent bugs with Safari -->
                    <option disabled value="">Salutation</option>
                  </template>
                </b-form-select>
              </b-form-group>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Nom") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Nom')"
                    v-model="form.Nom"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Prénom") }}</label>
                  <b-form-input
                    class="input-text-form"
                    v-model="form.Prenom"
                    :placeholder="$t('Prénom')"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Profession") }}</label>
                  <b-form-input
                    class="input-text-form"
                    v-model="form.Profession"
                    :placeholder="$t('Profession')"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Courriel") }}</label>
                  <b-form-input
                    class="input-text-form"
                    v-model="form.Courriel"
                    :placeholder="$t('Courriel')"
                    type="email"
                    required
                    :disabled="client.Validation_isUser === 1"
                  ></b-form-input>
                </b-form-group>
                <span class="error-message" v-if="failCourriel === true">
                  Courriel non conforme
                </span>
                <span class="error-logo" v-if="failCourriel === true">
                  <img src="../assets/error_logo.svg" />
                </span>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{
                    $t("Où avez-vous entendu parler de nous?")
                  }}</label>
                  <b-form-select
                    v-model="form.Provenance"
                    class="input-select-form"
                    :options="param.Values_Provenances"
                  >
                    <template #first>
                      <!-- This is required to prevent bugs with Safari -->
                      <option disabled value="">{{ $t("Provenances") }}</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="title-sections-form">
            <p>Adresse résidentielle</p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Adresse Ligne 1") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Adresse Ligne 1')"
                    v-model="form.Adresse_Ligne1"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Adresse Ligne 2") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Adresse Ligne 2')"
                    v-model="form.Adresse_Ligne2"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Ville") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Ville')"
                    v-model="form.Adresse_Ville"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Code Postal") }}</label>
                  <b-form-input
                    :placeholder="$t('Code Postal')"
                    class="input-text-form"
                    v-model="form.Adresse_CodePostal"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Province") }}</label>
                  <b-form-select
                    v-model="region"
                    class="input-select-form"
                    :options="regionsOption"
                  >
                    <template #first>
                      <!-- This is required to prevent bugs with Safari -->
                      <option disabled value="">{{ $t("Province") }}</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Pays") }}</label>
                  <b-form-select
                    class="input-select-form"
                    v-model="country"
                    :options="countries2"
                  >
                    <template #first>
                      <!-- This is required to prevent bugs with Safari -->
                      <option disabled value="">{{ $t("Pays") }}</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Téléphone résidence") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Téléphone résidence')"
                    v-model="form.Telephone_Residence"
                    type="text"
                    :formatter="acceptNumber"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Téléphone cellulaire") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Téléphone cellulaire')"
                    v-model="form.Telephone_Cellulaire"
                    type="text"
                    :formatter="acceptNumber"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Téléphone bureau") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Téléphone bureau')"
                    v-model="form.Telephone_Bureau"
                    type="text"
                    :formatter="acceptNumber"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Poste") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Poste')"
                    v-model="form.Telephone_Bureau_Poste"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Téléphone Urgence") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Téléphone Urgence')"
                    v-model="form.Telephone_Urgence"
                    type="text"
                    :formatter="acceptNumber"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Nom Contact Urgence") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Nom Contact Urgence')"
                    v-model="form.Telephone_Urgence_Nom"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Lien") }}</label>
                  <b-form-input
                    class="input-text-form"
                    :placeholder="$t('Lien')"
                    v-model="form.Telephone_Urgence_Lien"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="title-sections-form">
            <p>Allergies</p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Allergies") }}</label>
                  <b-form-tags
                    id="tags-component-select"
                    v-model="form.Allergie"
                    size="lg"
                    style="border: none"
                    class="mb-2"
                    add-on-change
                    no-outer-focus
                  >
                    <template
                      v-slot="{
                        tags,
                        inputAttrs,
                        inputHandlers,
                        disabled,
                        removeTag,
                      }"
                    >
                      <b-form-select
                        v-bind="inputAttrs"
                        :placeholder="$t('Allergie')"
                        class="input-select-form"
                        v-on="inputHandlers"
                        :disabled="
                          disabled || (param.Values_Allergies && param.Values_Allergies.length === 0 )
                        "
                        :options="param.Values_Allergies ?param.Values_Allergies:[]"
                      >
                        <template #first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option disabled value="">
                            Déterminer vos allergies
                          </option>
                        </template>
                      </b-form-select>
                      <div class="d-inline-block">
                        <ul
                          v-if="tags.length > 0"
                          class="list-inline d-inline-block mb-3"
                        >
                          <li
                            v-for="tag in tags"
                            :key="tag"
                            class="list-inline-item"
                          >
                            <b-form-tag
                              @remove="removeTag(tag)"
                              :title="tag"
                              :disabled="disabled"
                              variant="secondary"
                              >{{ tag }}</b-form-tag
                            >
                          </li>
                        </ul>
                      </div>
                    </template>
                  </b-form-tags>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="title-sections-form">
            <p>Préférences Avion</p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3" style="margin: 0px">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Préférence siège (sans garantie)") }}</label>
                  <b-form-select
                    v-model="form.PreselectionSiege_Choix"
                    :options="param.Values_PreselectionsSiege"
                    class="input-select-form"
                  >
                    <template #first>
                      <!-- This is required to prevent bugs with Safari -->
                      <option disabled value="">
                        Préférence siège (sans garantie)
                      </option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>
          <br />
          <div>
            <div class="row-line-inputs grid-3">
              <div class="input-container"></div>
              <div class="input-container">
                <b-button
                  variant="dark"
                  class="boutonConfirm"
                  @click="showModal"
                >
                  Enregistrer
                </b-button>
              </div>
            </div>
          </div>
          &nbsp;
        </b-form>
        <b-form
          id="passeport"
          class="contents-profils-form"
          @submit="onSubmit"
          v-show="mode === 'passeport'"
        >
          <div class="title-sections-form">
            <p style="margin: 0px">Information du passeport</p>
            <p class="sous-info">
              <span style="padding-right: 10px"
                ><img src="../assets/error_logo.svg" /></span
              >Il est essentiel que les informations inscrites dans cette
              section soient identiques à celles sur votre passeport.
            </p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Prénom sur le passeport") }}</label>
                  <b-form-input
                    :placeholder="$t('Prénom sur le passeport')"
                    class="input-text-form"
                    v-model="form.Passeport_Prenom"
                    type="text"
                    required
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Nom sur le passeport") }}</label>
                  <b-form-input
                    :placeholder="$t('Nom sur le passeport')"
                    class="input-text-form"
                    v-model="form.Passeport_Nom"
                    type="text"
                    required
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Sexe") }}</label>
                  <b-form-input
                    :placeholder="$t('Sexe')"
                    class="input-text-form"
                    v-model="Sexe"
                    type="text"
                    required
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Numéro du passeport") }}</label>
                  <b-form-input
                    :placeholder="$t('Numéro du passeport')"
                    class="input-text-form"
                    v-model="form.Passeport_Numero_Cache"
                    :formatter="maskNumber"
                    type="text"
                    required
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Lieu de naissance") }}</label>
                  <b-form-input
                    :placeholder="
                      $t('Lieu de naissance inscrit sur le passeport')
                    "
                    class="input-text-form"
                    v-model="form.Passeport_Naissance_Lieu"
                    type="text"
                    required
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <label>{{ $t("Date de naissance") }}</label>
                <b-form-group>
                  <b-form-input
                    v-model="form.Passeport_Naissance_Jour"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Jour')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                  <b-form-input
                    v-model="form.Passeport_Naissance_Mois"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Mois')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                  <b-form-input
                    v-model="form.Passeport_Naissance_Annee"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Année')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <label>{{ $t("Date de délivrance") }}</label>
                <b-form-group>
                  <b-form-input
                    v-model="form.Passeport_Delivrance_Jour"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Jour')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                  <b-form-input
                    v-model="form.Passeport_Delivrance_Mois"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Mois')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                  <b-form-input
                    v-model="form.Passeport_Delivrance_Annee"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Année')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <label>{{ $t("Date d&rsquo;expiration") }}</label>
                <b-form-group>
                  <b-form-input
                    v-model="form.Passeport_Expiration_Jour"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Jour')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                  <b-form-input
                    v-model="form.Passeport_Expiration_Mois"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Jour')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                  <b-form-input
                    v-model="form.Passeport_Expiration_Annee"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Année')"
                    style="width: 33%; display: unset"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Nationalité") }}</label>
                  <b-form-input
                    v-model="nationalite"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Nationalité inscrit sur le passeport')"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Autorité de délivrance") }}</label>
                  <b-form-input
                    :placeholder="$t('Autorité de délivrance')"
                    class="input-text-form"
                    v-model="form.Passeport_Delivrance_Autorite"
                    type="text"
                    required
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <b-row>
              <b-col lg="6" cols="12">
                <p
                  v-if="form.Passeport_Mention !== '*Expiré'"
                  style="font-weight: bold"
                  :style="{ color: form.Passeport_Mention_Couleur }"
                >
                  {{ form.Passeport_Mention }}
                </p>
                <p
                  v-if="form.Passeport_Mention === '*Expiré'"
                  style="font-weight: bold; color: #e64747"
                  :style="{ color: form.Passeport_Mention_Couleur }"
                >
                  {{ form.Passeport_Mention }}
                </p>
              </b-col>
            </b-row>
            <div>
              <div style="margin-bottom: 40px">
                <div style="width: 50%; margin: auto">
                  <div class="input-container"></div>
                  <div class="input-container">
                    <b-button
                      variant="dark"
                      class="boutonConfirm"
                      @click="showPassport"
                      >Modifier les informations de passeport</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-form>
        <b-modal
          ref="passport-modal"
          hide-footer
          hide-header
          :centered="true"
          body-class="paddingNone"
          content-class="passportRadius"
          style="border-radius: 20px"
          size="lg"
        >
          <b-form
            @submit.prevent="saveClient"
            @reset.prevent="hidePassport"
            style="border-radius: 20px"
          >
            <div class="topSection">Information du Passeport</div>
            <div class="title-sections-form">
              <p>Passeport</p>
            </div>
            <div class="error">* Tous les champs sont requis</div>
            <div class="container-form-inputs" style="padding-top: 40px">
              <div class="passeportSectionScrollable">
                <div class="row-line-inputs grid-3">
                  <div class="input-container">
                    <b-form-group>
                      <label>{{ $t("Prénom sur le passeport") }}</label>
                      <b-form-input
                        :placeholder="$t('Prénom sur le passeport')"
                        class="input-text-form"
                        v-model="form.Passeport_Prenom"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="input-container">
                    <b-form-group>
                      <label>{{ $t("Nom sur le passeport") }}</label>
                      <b-form-input
                        :placeholder="$t('Nom sur le passeport')"
                        class="input-text-form"
                        v-model="form.Passeport_Nom"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="input-container">
                    <b-form-group>
                      <label>{{ $t("Sexe") }}</label>
                      <b-form-select
                        v-model="form.Sexe"
                        :options="param.Values_Sexe"
                        class="input-select-form"
                        :placeholder="$t('Sexe')"
                      >
                        <template #first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option disabled value="">
                            Choisir votre sexe...
                          </option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div class="row-line-inputs grid-3">
                  <div class="input-container">
                    <b-form-group>
                      <label>{{ $t("Numéro du passeport") }}</label>
                      <b-form-input
                        :placeholder="$t('Numéro du passeport')"
                        class="input-text-form"
                        v-model="Passeport_Numero_Temp"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="input-container">
                    <b-form-group>
                      <label>{{ $t("Lieu de naissance") }}</label>
                      <b-form-input
                        :placeholder="
                          $t('Lieu de naissance inscrit sur le passeport')
                        "
                        class="input-text-form"
                        v-model="form.Passeport_Naissance_Lieu"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <b-row class="passportSpacing">
                  <b-col>
                    <div class="input-container">
                      <label>{{ $t("Date de naissance") }}</label>
                      <b-form-group class="date-group">
                        <b-form-select
                          v-model="form.Passeport_Naissance_Jour"
                          :options="days"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">JJ</option>
                          </template>
                        </b-form-select>
                        <b-form-select
                          v-model="form.Passeport_Naissance_Mois"
                          :options="months"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">MM</option>
                          </template>
                        </b-form-select>
                        <b-form-select
                          v-model="form.Passeport_Naissance_Annee"
                          :options="birthYears"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">AAAA</option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col>
                    <div class="input-container">
                      <label>{{ $t("Date de délivrance") }}</label>
                      <b-form-group class="date-group">
                        <b-form-select
                          v-model="form.Passeport_Delivrance_Jour_Temp"
                          :options="days"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">JJ</option>
                          </template>
                        </b-form-select>
                        <b-form-select
                          v-model="form.Passeport_Delivrance_Mois_Temp"
                          :options="months"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">MM</option>
                          </template>
                        </b-form-select>
                        <b-form-select
                          v-model="form.Passeport_Delivrance_Annee_Temp"
                          :options="deliveryYears"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">AAAA</option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="passportSpacing">
                  <b-col cols="6">
                    <div class="input-container">
                      <label>{{ $t("Date d&rsquo;expiration") }}</label>
                      <b-form-group class="date-group">
                        <b-form-select
                          v-model="form.Passeport_Expiration_Jour_Temp"
                          :options="days"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">JJ</option>
                          </template>
                        </b-form-select>
                        <b-form-select
                          v-model="form.Passeport_Expiration_Mois_Temp"
                          :options="months"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">MM</option>
                          </template>
                        </b-form-select>
                        <b-form-select
                          v-model="form.Passeport_Expiration_Annee_Temp"
                          :options="expirationYears"
                          class="input-select-form"
                          style="width: 33%"
                          required
                        >
                          <template #first>
                            <!-- This is required to prevent bugs with Safari -->
                            <option disabled :value="NULL">AAAA</option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
                <div class="row-line-inputs grid-3">
                  <div class="input-container">
                    <b-form-group>
                      <label>{{ $t("Nationalité") }}</label>
                      <b-form-select
                        v-model="form.Passeport_Nationalite"
                        :options="param.Values_Nationalites"
                        class="input-select-form"
                        :placeholder="
                          $t('Nationalité inscrit sur le passeport')
                        "
                      >
                        <template #first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option disabled value="">
                            Sélectionner une nationalité....
                          </option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="input-container">
                    <b-form-group>
                      <label>{{ $t("Autorité de délivrance") }}</label>
                      <b-form-input
                        :placeholder="$t('Autorité de délivrance')"
                        class="input-text-form"
                        v-model="form.Passeport_Delivrance_Autorite_Temp"
                        type="text"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <b-row class="passportSpacing">
                  <b-col lg="6" cols="12">
                    <b-form-group
                      :label="
                        $t(
                          'Téléverser une image des pages 2-3 de votre passeport valide'
                        )
                      "
                    >
                      <b-form-file
                        v-model="file1"
                        :state="
                          file1 !== null
                        "
                        required
                        browse-text="Parcourir"
                        placeholder="Déposer votre fichier ici..."
                      ></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <b-row>
                <b-col>
                  <div class="input-container">
                    <b-button variant="dark" class="boutonConfirm" type="reset"
                      >Annuler</b-button
                    >
                  </div>
                </b-col>
                <b-col>
                  <div class="input-container">
                    <b-button variant="dark" class="boutonConfirm" type="submit"
                      >Enregistrer les informations</b-button
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </b-modal>
        <b-form
          id="assurance"
          class="contents-profils-form"
          @submit="onSubmit"
          v-show="mode === 'assurance'"
        >
          <div class="title-sections-form">
            <p style="margin: 0px">ASSURANCE VOYAGE PERSONNELLE</p>
            <p class="sous-info">
              À compléter avec les renseignements de votre assurance s’il y a
              lieu
            </p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Compagnie(s)") }}</label>
                  <b-form-input
                    :placeholder="$t('Compagnie(s)')"
                    class="input-text-form"
                    v-model="form.Assurance_Personnelle_Compagnie"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label>{{ $t("Numéro(s) de contrat(s)") }}</label>
                  <b-form-input
                    :placeholder="$t('Numéro(s) de contrat(s)')"
                    class="input-text-form"
                    v-model="form.Assurance_Personnelle_Contrat"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <label style="height: 60px">{{
                  $t("Montant(s) de couverture annulation")
                }}</label>
                <b-form-group>
                  <b-form-input
                    :placeholder="$t('Montant(s) de couverture annulation')"
                    class="input-text-form"
                    v-model="form.Assurance_Personnelle_CouvertureAnnulation"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label style="height: 60px">{{
                    $t("Montant(s) de couverture médicale")
                  }}</label>
                  <b-form-input
                    :placeholder="$t('Montant(s) de couverture médicale')"
                    class="input-text-form"
                    v-model="form.Assurance_Personnelle_CouvertureMedicale"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <label style="height: 60px">{{
                    $t(
                      "Téléphone assistance de votre assureur (numéro à frais virés) "
                    )
                  }}</label>
                  <b-form-input
                    :placeholder="$t('Téléphone assistance de votre assureur')"
                    class="input-text-form"
                    v-model="form.Assurance_Personnelle_Telephone"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="title-sections-form">
            <p style="margin: 0px">ASSURANCE ANNUELLE</p>
            <p class="sous-info">
              Pour usage interne de Voyages Lambert (non modifiable)
            </p>
            <p class="sous-info" v-if="form.Assurance_Annuelle_Expiree === 1">
              <span style="padding-right: 10px"
                ><img src="../assets/error_logo.svg" /></span
              >EXPIRÉE
            </p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group :label="$t('Numéro de contrat')">
                  <b-form-input
                    :placeholder="$t('Numéro de contrat')"
                    :class="
                      form.Assurance_Annuelle_Expiree === 1
                        ? 'input-error-form'
                        : 'input-text-form'
                    "
                    v-model="form.Assurance_Annuelle_Contrat"
                    :disabled="true"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group :label="$t('Nombre de jours')">
                  <b-form-input
                    :placeholder="$t('Nombre de jours')"
                    :class="
                      form.Assurance_Annuelle_Expiree === 1
                        ? 'input-error-form'
                        : 'input-text-form'
                    "
                    v-model="form.Assurance_Annuelle_Jours"
                    type="text"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group :label="$t('Expiration')">
                  <b-form-input
                    :placeholder="$t('Expiration')"
                    :class="
                      form.Assurance_Annuelle_Expiree === 1
                        ? 'input-error-form'
                        : 'input-text-form'
                    "
                    v-model="form.Assurance_Annuelle_Expiration_Texte"
                    type="text"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <b-row>
              <b-col lg="6" cols="12">
                <b-form-group
                  :label="$t('Document d\'assurance annuelle')"
                  v-if="form.Assurance_Annuelle_Doc"
                >
                  <a
                    class="downloadLink"
                    @click="downloadDoc(form.Assurance_Annuelle_Doc)"
                    >Cliquer ici pour télécharger votre contrat d’assurance.</a
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <div>
              <div class="row-line-inputs grid-3">
                <div class="input-container"></div>
                <div class="input-container">
                  <b-button
                    variant="dark"
                    class="boutonConfirm"
                    @click="showModal"
                  >
                    Enregistrer
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
        <b-form
          id="paiement"
          class="contents-profils-form"
          @submit="onSubmit"
          v-show="mode === 'paiement'"
        >
          <div class="title-sections-form">
            <p style="margin: 0px">Carte de crédit</p>
            <p class="sous-info" v-show="form.CarteCredit_Expiree === 1">
              <span style="padding-right: 10px"
                ><img src="../assets/error_logo.svg" /></span
              >EXPIRÉE
            </p>
          </div>
          <div class="container-form-inputs">
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group :label="$t('Type')">
                  <b-form-input
                    class="input-text-form"
                    v-model="form.CarteCredit_Type"
                    :disabled="true"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group :label="$t('Numéro')">
                  <b-form-input
                    class="input-text-form"
                    v-model="form.CarteCredit_Numero"
                    :disabled="true"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row-line-inputs grid-3">
              <div class="input-container">
                <b-form-group :label="$t('Expiration')">
                  <b-form-input
                    v-model="form.CarteCredit_Expiration_Mois"
                    :disabled="true"
                    class="input-text-form"
                    :placeholder="$t('Mois')"
                    style="width: 45%; display: unset; margin-right: 10px"
                    type="text"
                  ></b-form-input>
                  <b-form-input
                    v-model="form.CarteCredit_Expiration_Annee"
                    :disabled="true"
                    :placeholder="$t('Annee')"
                    class="input-text-form"
                    style="width: 45%; display: unset"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group :label="$t('CVV')">
                  <b-form-input
                    class="input-text-form"
                    v-model="form.CarteCredit_CVV"
                    :disabled="true"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div style="margin-bottom: 40px">
              <div style="width: 50%; margin: auto">
                <div class="input-container"></div>
                <div class="input-container">
                  <b-button
                    variant="dark"
                    class="boutonConfirm"
                    @click="toggleModal"
                    >Modifier les informations de carte de crédit</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </b-form>
        <b-modal
          ref="credit-modal"
          hide-footer
          hide-header
          :centered="true"
          body-class="paddingNone"
          content-class="radius"
          style="border-radius: 20px"
        >
          <b-form
            @submit.prevent="saveCredit"
            @reset.prevent="toggleModal"
            style="border-radius: 20px"
          >
            <div class="topSection">MODE DE PAIEMENT</div>
            <div class="title-sections-form">
              <p>Carte de crédit</p>
            </div>
            <div class="error">* Tous les champs sont requis</div>
            <div class="container-form-inputs">
              <div class="input-container">
                <b-form-group>
                  <b-form-select
                    class="input-select-form"
                    v-model="credit.CarteCredit_Type"
                    :options="param.Values_CreditCard_Types"
                    required
                  >
                    <template #first>
                      <!-- This is required to prevent bugs with Safari -->
                      <option disabled :value="undefined">Type</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
              <div class="input-container">
                <b-form-group>
                  <b-form-input
                    :placeholder="$t('Numéro')"
                    class="input-text-form"
                    v-model="credit.CarteCredit_Numero"
                    required
                    type="text"
                    :formatter="acceptCreditNumber"
                  ></b-form-input>
                </b-form-group>
              </div>
              <b-row>
                <b-col cols="9">
                  <div class="input-container">
                    <label>{{ $t("Expiration") }}</label>
                    <b-form-group class="date-group">
                      <b-form-select
                        v-model="credit.CarteCredit_Expiration_Mois"
                        :options="monthsCredit"
                        class="input-select-form"
                        required
                        style="width: 55%; display: unset; margin-right: 10px"
                      >
                        <template #first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option disabled :value="undefined">Mois</option>
                        </template>
                      </b-form-select>
                      <b-form-select
                        v-model="credit.CarteCredit_Expiration_Annee"
                        :options="creditYears"
                        class="input-select-form"
                        style="width: 40%; display: unset"
                        required
                      >
                        <template #first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option disabled :value="undefined">Année</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="3">
                  <div class="input-container">
                    <label>{{ $t("CVV") }}</label>
                    <b-form-group class="date-group">
                      <b-form-input
                        class="input-text-form"
                        placeholder="***"
                        v-model="credit.CarteCredit_CVV"
                        required
                        type="text"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <div class="input-container" style="margin-bottom: 25px">
                <b-button variant="dark" class="boutonConfirm" type="reset"
                  >Annuler</b-button
                >
              </div>
              <div class="input-container">
                <b-button variant="dark" class="boutonConfirm" type="submit"
                  >Enregistrer les informations</b-button
                >
              </div>
            </div>
          </b-form>
        </b-modal>
      </b-col>
    </b-row>
    <b-modal
      ref="my-modal"
      hide-footer
      hide-header
      :centered="true"
      body-class="paddingNone"
      content-class="radius"
      style="border-radius: 20px"
    >
      <b-form style="border-radius: 20px">
        <div class="topSection">Sauvegarder</div>
        <div class="title-sections-form">
          <p>Voulez-vous sauvegarder vos modification ?</p>
        </div>
        <div class="container-form-inputs">
          <div class="input-container" style="margin-bottom: 25px">
            <b-button variant="dark" class="boutonConfirm" @click="hideModal"
              >Annuler</b-button
            >
          </div>
          <div class="input-container">
            <b-button variant="dark" class="boutonConfirm" @click="saveClient"
              >Enregistrer</b-button
            >
          </div>
        </div>
      </b-form>
    </b-modal>
    <b-modal
      ref="saveQuit"
      hide-footer
      hide-header
      :centered="true"
      body-class="paddingNone"
      content-class="radius"
      style="border-radius: 20px"
    >
      <b-form style="border-radius: 20px">
        <div class="topSection">Sauvegarder</div>
        <div class="title-sections-form">
          <p>Voulez-vous sauvegarder avant de quitter</p>
        </div>
        <div class="container-form-inputs">
          <div class="input-container" style="margin-bottom: 25px">
            <b-button variant="dark" class="boutonConfirm" @click="hideSave"
              >Quitter</b-button
            >
          </div>
          <div class="input-container">
            <b-button variant="dark" class="boutonConfirm" @click="saveClient"
              >Enregistrer</b-button
            >
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import json from "@/assets/countries.json";
import json2 from "@/assets/countries2.json";
import nationalites from "@/assets/nationalites.json";
import { mapState, mapActions } from "vuex";
export default {
  name: "Client",
  components: {},
  data() {
    return {
      oldMaskPasseport_Numero: "",
      newMaskPasseport_Numero: "",
      countries1: json,
      countries2: json2,
      nationalities: nationalites,
      regionsOption: [],
      months: [],
      Passeport_Numero_Temp: "",
      monthsCredit: [],
      days: [],
      birthYears: [],
      deliveryYears: [],
      expirationYears: [],
      creditYears: [],
      country: "",
      region: "",
      failCourriel: true,
      file1: null,
      clientSelect: null,
      selected: null,
      clientOption: [],
      form: { empty: true },
      to: null,
      mode: "renseignement",
      credit: {},
      quit: false,
      classSelect: {
        renseignement: "item-tabs-menu active-tabs",
        passeport: "item-tabs-menu",
        paiement: "item-tabs-menu",
        assurance: "item-tabs-menu",
      },
    };
  },
  computed: {
    ...mapState({
      param: (state) => state.param.param,
      clients: (state) => state.client.list,
      client: (state) => state.client.current,
      doc: (state) => state.container.list,
    }),
    openDoc(id) {
      if (this.doc[id]) {
        return this.doc[id].base64;
      }
      return "";
    },
    nationalite(){
      if(this.form.Passeport_Nationalite && this.form.Passeport_Nationalite !== null){
        if(Array.isArray(this.param.Values_Nationalites)){
          for(const country of this.param.Values_Nationalites){
            if(country.value === this.form.Passeport_Nationalite){
              return country.text
            }
          }
        }

      }
      return ''
    },
    Sexe: {
      get() {
        if (this.form.Sexe == "M") {
          return "Masculin";
        } else if (this.form.Sexe == "F") {
          return "Féminin";
        } else if (this.form.Sexe == "X") {
          return "Un autre genre";
        } else {
          return "";
        }
      },
      set(val) {
        this.statusProxy = val;
      },
    },
    courrielState() {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test(this.form.Courriel) === true) {
        this.failCourriel = false;
        return true;
      } else {
        this.failCourriel = true;
        return false;
      }
    },
  },
  watch: {
    form() {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test(this.form.Courriel) === true) {
        this.failCourriel = false;
      } else {
        this.failCourriel = true;
      }
    },
    clients() {
      this.clientOption = [];
      for (let i in this.clients) {
        const client = this.clients[i];
        if (client.Validation_isUser === 1) {
          this.clientOption.push({
            value: client.a__pk,
            text: client.Nom + ", " + client.Prenom + " (Principal)",
          });
        } else {
          this.clientOption.push({
            value: client.a__pk,
            text: client.Nom + ", " + client.Prenom,
          });
        }
      }
      if (this.clientOption[0] && this.clientSelect === null) {
        this.clientSelect = this.clientOption[0].value;
      }
    },
    country() {
      this.regionsOption = [];
      let arrayRegion = [];
      this.form.Adresse_PaysCode = this.country;
      for (let i in this.countries1) {
        let country = this.countries1[i];
        if (country.countryShortCode === this.country) {
          for (let j in country.regions) {
            let region = country.regions[j];
            this.regionsOption.push({
              value: region.shortCode,
              text: region.shortCode,
            });
            arrayRegion.push(this.regionsOption[j].value);
          }
          if (arrayRegion.indexOf(this.region) === -1) {
            this.region = "";
          }
          break;
        }
      }
    },
    region() {
      this.form.Adresse_Province = this.region;
    },
    clientSelect() {
      if (
        JSON.stringify(this.form) !== JSON.stringify(this.client) &&
        this.form.empty !== true
      ) {
        let form = this.form;
        this.putClient({ id: this.form.a__pk, param: { fields: form } });
        this.getClient(this.clientSelect);
      } else {
        this.getClient(this.clientSelect);
      }
    },
    client() {
      this.form = JSON.parse(JSON.stringify(this.client));
      this.oldMaskPasseport_Numero = this.maskNumber(
        this.form.Passeport_Numero
      );
      this.country = this.form.Adresse_PaysCode;
      this.region = this.form.Adresse_Province;
    },
  },
  methods: {
    ...mapActions([
      "getParam",
      "getClients",
      "getClient",
      "putClient",
      "postClient",
      "deleteClient",
      "postCreditCard",
      "getContainer",
      "postContainer",
    ]),
    onSubmit(event) {
      event.preventDefault();
    },
    changeMode(type) {
      this.mode = type;
      this.classSelect.renseignement = "item-tabs-menu";
      this.classSelect.assurance = "item-tabs-menu";
      this.classSelect.passeport = "item-tabs-menu";
      this.classSelect.paiement = "item-tabs-menu";
      this.classSelect[type] = "item-tabs-menu active-tabs";
    },
    saveClient() {
      let form = this.form;
      if (this.Passeport_Numero_Temp) {
        form.Passeport_Numero = this.Passeport_Numero_Temp;
        form.Passeport_Delivrance_Annee = form.Passeport_Delivrance_Annee_Temp;
        form.Passeport_Delivrance_Autorite =
          form.Passeport_Delivrance_Autorite_Temp;
        form.Passeport_Delivrance_Jour = form.Passeport_Delivrance_Jour_Temp;
        form.Passeport_Delivrance_Mois = form.Passeport_Delivrance_Mois_Temp;
        form.Passeport_Expiration_Annee = form.Passeport_Expiration_Annee_Temp;
        form.Passeport_Expiration_Jour = form.Passeport_Expiration_Jour_Temp;
        form.Passeport_Expiration_Mois = form.Passeport_Expiration_Mois_Temp;
        form.Passeport_ToUpdate = 1;
      } else {
        delete form.Passeport_Numero;
        delete form.Passeport_Delivrance_Annee;
        delete form.Passeport_Delivrance_Autorite;
        delete form.Passeport_Delivrance_Jour;
        delete form.Passeport_Delivrance_Mois;
        delete form.Passeport_Expiration_Annee;
        delete form.Passeport_Expiration_Jour;
        delete form.Passeport_Expiration_Mois;
      }
      if (this.file1) {
        this.postContainer({
          id: this.form.a__pk,
          param: {
            file: this.file1,
            field: "Passeport_Photo",
            table: "layouts/API_Clients",
          },
        });
      }
      console.log(form)
      delete form.Passeport_Numero_Cache;
      this.putClient({ id: this.form.a__pk, param: { fields: form } });
      this.Passeport_Numero_Temp = "";
      this.hidePassport();
      this.hideModal();
      this.hideSave();
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    showSave() {
      this.$refs["saveQuit"].show();
    },
    hideSave() {
      this.$refs["saveQuit"].hide();
      this.quit = true;
      if (this.to !== null) {
        this.$router.push(this.to);
      }
    },
    showPassport() {
      this.$refs["passport-modal"].show();
    },
    hidePassport() {
      this.$refs["passport-modal"].hide();
    },
    createClient() {
      this.postClient({ param: { fields: { Nom: "Nouveau client" } } });
    },
    deleteAClient() {
      this.deleteClient({ id: this.form.a__pk });
    },
    acceptNumber(value) {
      var x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      value = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
      return String(value).substring(0, 14);
    },
    acceptCreditNumber(value) {
      var x = value.trim();
      x = x.replace(/\D/g, "");
      return String(x).substring(0, 16);
    },
    acceptCreditMonth(value) {
      var x = value.trim();
      x = x.replace(/\D/g, "");
      return String(x).substring(0, 2);
    },
    acceptCreditYear(value) {
      var x = value.trim();
      x = x.replace(/\D/g, "");
      return String(x).substring(0, 4);
    },
    acceptCreditCVV(value) {
      var x = value.trim();
      x = x.replace(/\D/g, "");
      return String(x).substring(0, 4);
    },
    saveCredit() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.postCreditCard({
        id: this.form.a__pk,
        param: { fields: this.credit },
      });
      this.credit = {};
      this.$refs["credit-modal"].toggle("#toggle-btn");
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.credit = {};
      this.$refs["credit-modal"].toggle("#toggle-btn");
    },
    async downloadDoc(id) {
      if (id.indexOf("http") === -1) {
        // download
        document.body.classList.add('inheritCursors');
        document.body.style.cursor = 'progress'
        let data = await this.getContainer(id);
        var byteCharacters = data.Base64.replace(/\r\n/g, "");
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: "application/pdf;base64" });
        const link = document.createElement("a");
        link.href = "data:image/pdf;base64," + data.Base64;
        link.download = data.Filename;
        link.target = "_blank";
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.style.cursor = 'default'
        document.body.classList.remove('inheritCursors');
      } else {
        window.open(id, "_blank");
      }
    },
    maskNumber(value) {
      let data = value;
      if(data){
        if (data.length > this.form.Passeport_Numero.length) {
          this.form.Passeport_Numero += data.substring(
            this.form.Passeport_Numero.length
          );
          data = this.form.Passeport_Numero;
        } else if (data.length < this.form.Passeport_Numero.length) {
          this.form.Passeport_Numero = this.form.Passeport_Numero.substring(
            0,
            data.length
          );
          data = this.form.Passeport_Numero;
        }
        const passLength = data.length;
        let masked = data.substring(0, passLength - 4);
        masked = masked.replace(/./g, "•"); //The character is ASCII-7 (Press Alt+7 to type)
        const text = data.substring(passLength - 4);
        return masked + text;
      }
      return ''
    },
  },
  mounted() {
    for (let i = 1; i <= 31; i++) {
      let v = i;
      if (v < 10) {
        v = "0" + i;
      } else {
        v = "" + i + "";
      }
      this.days.push({
        value: v,
        text: v,
      });
    }
    let currentYear = new Date().getFullYear();
    for (let i = currentYear; i <= currentYear + 10; i++) {
      this.creditYears.push({
        value: i,
        text: i,
      });
      this.expirationYears.push({
        value: i,
        text: i,
      });
    }
    for (let i = currentYear - 100; i <= currentYear; i++) {
      this.birthYears.push({
        value: i,
        text: i,
      });
    }
    for (let i = currentYear - 10; i <= currentYear; i++) {
      this.deliveryYears.push({
        value: i,
        text: i,
      });
    }
    let months = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];

    for (let i = 0; i < months.length; i++) {
      this.months.push({
        value: months[i],
        text: months[i],
      });
    }
    let monthsCredit = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];

    for (let i = 0; i < monthsCredit.length; i++) {
      this.monthsCredit.push({
        value: i + 1,
        text: monthsCredit[i],
      });
    }
    //do something after mounting vue instance
  },
  created() {
    //do something after creating vue instance
    this.getParam();
    this.getClients();
  },
  beforeRouteLeave(to, from, next) {
    if (
      JSON.stringify(this.form) !== JSON.stringify(this.client) &&
      this.quit === false
    ) {
      this.to = to;
      this.showSave();
      next(false);
    } else {
      next(true);
    }
  },
};
</script>

<style scoped>
.container {
  background-color: #ffffff;
  padding-bottom: 10px;
}
.input-text-form:focus-within {
  outline: none !important;
  box-shadow: none !important;
}
.custom-select {
  outline: none !important;
  box-shadow: none !important;
}
.error {
  padding-left: 50px;
  color: #ff0000;
  font-weight: 500;
}
.b-form-tag {
  text-align: left;
  letter-spacing: 0px;
  color: #313439 !important;
  background: #e7eced 0% 0% no-repeat padding-box;
  border-radius: 100px;
  opacity: 1;
}
.b-form-tag > button.b-form-tag-remove {
  color: #313439;
  opacity: 1;
  font: normal normal bold 20px Catamaran;
}
.list-inline-item:not(:last-child) {
  margin-top: 15px;
}
.sous-info {
  text-align: left;
  font: normal normal bold 18px/28px Catamaran;
  letter-spacing: 0px;
  color: #7b7c7e;
  opacity: 1;
  text-transform: none;
}
.date-group {
  border: 2px solid rgba(2, 2, 2, 0.2);
  border-radius: 6px;
  padding: 5px;
}
/deep/.col-form-label {
  text-align: left;
  font: normal normal bold 16px/28px Catamaran;
  letter-spacing: 0px;
  color: #313439 !important;
  opacity: 0.4;
}
legend {
  text-align: left;
  font: normal normal bold 16px/28px Catamaran;
  letter-spacing: 0px;
  color: #313439 !important;
  opacity: 0.4;
}
label {
  text-align: left;
  font: normal normal bold 16px/28px Catamaran;
  letter-spacing: 0px;
  color: #313439 !important;
  opacity: 0.4;
}
.downloadLink {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
.downloadLink:hover {
  text-decoration: underline;
  cursor: pointer;
}
.topSection {
  background: #242629 0% 0% no-repeat padding-box;
  padding: 25px;
  opacity: 1;
  text-align: left;
  font: normal normal bold 32px/60px Catamaran;
  letter-spacing: 0px;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  border-radius: 18px 18px 0 0;
  margin-bottom: 30px;
}
/deep/.paddingNone {
  padding: 0px !important;
}
/deep/.radius {
  border-radius: 20px !important;
  width: 450px;
}
/deep/.passportRadius {
  border-radius: 20px !important;
}
.passportSpacing {
  margin-bottom: 60px;
}
.passeportSectionScrollable {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 50vh;
}
</style>
